module.exports = __webpack_public_path__ + "static/media/ellipse-white.8c4c46c1.svg";